import React from 'react'
import { Loadable } from 'loankeeper-common/components/hocs/LazyLoading'
import { createNavigationConfig } from 'loankeeper-common/components'

import OpenButton from './OpenButton'
import { instanceName as LOAN_SEARCH_MODAL } from './constants'

const ApplicationSearch = Loadable(() => import('./ApplicationSearchModal'))

const ApplicationSearchModal = ({ name }) => <ApplicationSearch name={name} mode="LoanAdd" />

export const createLoanSearchModalNavigationItem = createNavigationConfig((translateFn) => ({
  icon: 'loan_add',
  text: translateFn('mnu_loans_add'),
  identity: LOAN_SEARCH_MODAL,
  permission: ['ADD_LOAN', 'VIEW_APPLICATION'],
  component: ApplicationSearchModal,
}))

export { OpenButton }
